import { render, staticRenderFns } from "./codeConfirm.vue?vue&type=template&id=fac4d33a&scoped=true"
import script from "./codeConfirm.vue?vue&type=script&lang=js"
export * from "./codeConfirm.vue?vue&type=script&lang=js"
import style0 from "./codeConfirm.vue?vue&type=style&index=0&id=fac4d33a&prod&lang=scss&scoped=true"
import style1 from "./codeConfirm.vue?vue&type=style&index=1&id=fac4d33a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac4d33a",
  null
  
)

export default component.exports